// import { useState } from 'react'

// import { PureInput, RadioGroup, Label } from '@hhgtech/hhg-components'
import { CSSProperties } from 'react'

import { Button } from '@hhgtech/hhg-components/mantine'
import { Flex, rem } from '@mantine/core'

import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'

export type Props = {
  title: string
  onClick?: () => void
  style?: CSSProperties
  className?: string
  isMobile?: boolean
  link?: string
  toolName?: string
  source?: string
}

const ToolsSubmitButton = ({
  // className,
  // style,
  title,
  onClick,
  link,
  toolName,
  source,
}: Props) => {
  // const { formatMessage: f } = useIntl()
  const { locale } = useRouterExtend()

  return (
    <Flex justify={'center'}>
      <Button
        type="submit"
        onClick={onClick}
        size="md"
        dataEventCategory={source}
        dataEventAction={toolName}
        dataEventLabel={`https://${domainLocales[locale]}/${link}`}
        fullWidth
        sx={{
          maxWidth: rem(343),
        }}
      >
        {title}
      </Button>
    </Flex>
  )
}

export { ToolsSubmitButton }
